import { render, staticRenderFns } from "./OperaDetailsBWindow.vue?vue&type=template&id=8b35b7aa&scoped=true&"
import script from "./OperaDetailsBWindow.vue?vue&type=script&lang=js&"
export * from "./OperaDetailsBWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaDetailsBWindow.vue?vue&type=style&index=0&id=8b35b7aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b35b7aa",
  null
  
)

export default component.exports